import styled from 'styled-components';

import { Button } from '@components/button';
import { RelativeSpinner } from '@components/loading-spinner';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

/**
 * Shared loading / error / empty states for the journey lists (Manage tab,
 * per-job Journeys tab, job trigger selector, triggers sidebar) — previously
 * hand-rolled byte-identically in each of those files.
 */
export const JourneyListLoading = ({ dataCy }: { dataCy?: string }) => (
  <LoadingContainer data-cy={dataCy}>
    <RelativeSpinner />
  </LoadingContainer>
);

export const JourneyListError = ({
  description,
  retryLabel,
  onRetry,
  dataCy,
}: {
  description: string;
  retryLabel: string;
  onRetry(): void;
  dataCy?: string;
}) => (
  <ErrorContainer data-cy={dataCy}>
    <Stack space={2}>
      <Text font="regular14" color="textSecondary" text={description} />
      <Button variant="secondary" text={retryLabel} onClick={onRetry} />
    </Stack>
  </ErrorContainer>
);

export const JourneyListEmpty = ({ text, dataCy }: { text: string; dataCy?: string }) => (
  <EmptyContainer data-cy={dataCy}>
    <Text font="regular14" color="textHelper" text={text} />
  </EmptyContainer>
);

const LoadingContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.space[6],
});

const ErrorContainer = styled.div({
  padding: theme.space[4],
  backgroundColor: theme.color.uiTrans5,
  borderRadius: pxToRem(8),
  border: `${pxToRem(1)} solid ${theme.color.border10}`,
});

const EmptyContainer = styled.div({
  padding: theme.space[4],
  textAlign: 'center',
});
